import React from 'react';

/**
 * PageHero — the brand-green gradient banner used at the top of marketing
 * and content pages. Children render below the title/subtitle (e.g. CTAs).
 * The default bottom padding leaves room for a card to overlap via -mt-16.
 */
export default function PageHero({ title, subtitle, children, className = '' }) {
    return (
        <div className={`relative overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-emerald-900 text-white ${className}`}>
            <div className="absolute inset-0 opacity-10 pointer-events-none">
                <div className="absolute -top-10 left-1/4 w-72 h-72 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-400 rounded-full blur-3xl"></div>
            </div>
            <div className="relative z-10 text-center px-4 pt-14 pb-28">
                {title && <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">{title}</h1>}
                {subtitle && <p className="mt-4 text-lg text-brand-100 max-w-2xl mx-auto">{subtitle}</p>}
                {children}
            </div>
        </div>
    );
}
